module.exports = __webpack_public_path__ + "img/lanagent.ed9fb98a.jpg";